module.exports = __webpack_public_path__ + "img/AbdulkhaliqYa3qubi-WatayZhiyan.71c8b4cb.jpg";